module.exports = __webpack_public_path__ + "@/assets/img/klarway.47f3f3ed.png";